import API from "@services/root/rootApi";
import { Dispatch, SetStateAction } from "react";

export const getRoomTypes = async (accountId: string) => {
  const response = await API.get(`/symphony-api/provisioning/account/`, {
    params: {
      accountId,
    },
  });
  return response.data;
};

export const modifyIssues = async (
  accountId: string,
  name: string,
  data: string[]
) => {
  const response = await API.post(
    `/symphony-api/provisioning/account/issue/update?accountId=${accountId}&name=${name}`,

    data
  );
  return response.data;
};

export const postImportIssues = async (
  accountId: string,
  data: FormData,
  setProgress: Dispatch<SetStateAction<number>>,
  name: string
) => {
  const response = await API.post(
    `/symphony-api/provisioning/account/issue/import?accountId=${accountId}&name=${name}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.progress ?? 0) * 100;
        setProgress(progress);
      },
    }
  );
  return response;
};

export const postImportRoomTypes = async (
  accountId: string,
  data: FormData,
  setProgress: Dispatch<SetStateAction<number>>
) => {
  const response = await API.post(
    `/symphony-api/provisioning/room/type/import?accountId=${accountId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.progress ?? 0) * 100;
        setProgress(progress);
      },
    }
  );
  return response.data;
};
